export default __webpack_public_path__ + "static/media/aroma45.12808430.png";